<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>
        <span style="color:rgb(0,170,221)">Notifications</span>
      </p>
      <h2 class="mt-6">Notifications</h2>

      <div class="cell mt-10">
        <div class="d-flex flex-column align-center my-10">
          <v-textarea
            v-model="message"
            color="rgb(0,169,221)"
            style="width:500px;"
            :error-messages="messageErrors"
            outlined
            label="Message"
          ></v-textarea>

          <div class="d-flex">
            <v-radio-group v-model="radioGroup">
              <v-radio color="rgb(0,169,221)" label="Doctors" :value="1"></v-radio>
              <v-radio color="rgb(0,169,221)" label="Patients" :value="2"></v-radio>
            </v-radio-group>
          </div>

          <div class="d-flex">
            <v-btn
              rounded
              depressed
              class="white--text"
              color="rgb(0,169,221)"
              @click="open('Notifications')"
            >Send Notification</v-btn>
            <v-btn
              rounded
              depressed
              class="white--text ml-2"
              color="rgb(0,169,221)"
              @click="open('Announcement')"
            >Save As Announcement</v-btn>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-card-text>
          <div class="d-flex flex-column align-center py-10">
            <v-icon
              style="position:absolute; right:5px; top:5px; cursor: pointer;"
              @click="dialog=false"
            >mdi-close</v-icon>
            <h1 class="black--text">Send {{what}}?</h1>
            <p class="mt-5 black--text">Message:</p>
            <p class="text-center">{{message}}</p>

            <p class="black--text mt-5">
              Send To:
              <span
                style="color: rgb(0,169,221)"
              >{{radioGroup === 1 ? 'Doctors' : 'Patients'}}</span>
            </p>

            <div class="d-flex justify-center">
              <v-btn
                @click="dialog = false"
                outlined
                rounded
                color="rgb(164,164,164)"
                class="text-capitalize mt-10 px-10 mr-5"
              >Cancel</v-btn>

              <v-btn
                rounded
                depressed
                class="white--text text-capitalize mt-10 px-10"
                color="rgb(0,169,221)"
                @click="send"
              >Send</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
export default {
  mixins: [validationMixin],
  data() {
    return {
      radioGroup: 1,
      dialog: false,
      message: "",
      what: ""
    };
  },
  methods: {
    open(what) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.what = what;
        this.dialog = true;
      }
    },
    send() {
      console.log(this.what)
      if (this.what === "Notifications") {
       // Doctors
          // axios.post("https://fcm.googleapis.com/fcm/send", {
          //   headers: {
          //     'Content-type': 'application/json',
          //     'Authorization': 'key=AIzaSyDbEJs--6lXA_EfMbexu8i0Y49GJBQJBfY'
          //   },
          //   body: {
          //     'to': `/topic/${this.radioGroup === 1 ? 'doctors' : 'travellers'}`,
          //     'notification': {
          //       'title': "title",
          //       'body': "body"
          //     }
          //   }
          // })
          axios.post(`${process.env.VUE_APP_BASE_URL}admin/notifyAll`, {
            categoryToNotify: `${this.radioGroup === 1 ? 'doctors' : 'travellers'}`,
            title: 'Dn2me Notification',
            body: this.message,
            clickAction: ''
          })
          .then(res => {
            console.log(res)
          })
          .catch(err => {
            console.log(err)
          });
        
      
      }
    }
  },
  validations: {
    message: { required }
  },
  computed: {
    messageErrors() {
      const errors = [];
      if (!this.$v.message.$dirty) return errors;
      if (!this.$v.message.required) errors.push("This field is required");
      return errors;
    }
  }
};
</script>